import { render, staticRenderFns } from "./documents.accountspayable.vue?vue&type=template&id=a951e682&scoped=true"
import script from "./documents.accountspayable.vue?vue&type=script&lang=js"
export * from "./documents.accountspayable.vue?vue&type=script&lang=js"
import style0 from "./documents.accountspayable.vue?vue&type=style&index=0&id=a951e682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a951e682",
  null
  
)

export default component.exports